export default class RoleAdapter {

    constructor(role){
        this._role = role;
    }

    adapt() {
        return {
            "FRONTOFFICE_GENERAL_ADMINISTRATOR_ROLE": "Administrador",
            "FRONTOFFICE_ADMINISTRATIVE_ROLE": "Administrativo",
            "FRONTOFFICE_OPERATIONAL_ROLE": "Operativo",
        }[this._role];
    }
}